import { Routes, Route } from "react-router-dom";
import {
  AdminSidebar,
  Dashboard,
  ForumAdmin,
  DiscountCodesAdmin,
  FanClubsAdmin,
  FanMemoriesAdmin,
  CupsAdmin,
  AnalyticsAdmin,
  NotificationsAdmin,
  UsersAdmin,
  CrudSection,
  FixturesAdmin,
  NewsAdmin,
  HistoryAdmin,
  PlayersAdmin,
  ShopAdmin,
  TablesAdmin,
  StatsAdmin,
  MemesAdmin,
  TransfersAdmin,
  SeoHealthAdmin,
  OnThisDayAdmin
} from "../components/admin";

// Field definitions for CRUD sections
const entertainmentFields = [
  { name: "category", label: "Category", type: "select", options: ["books", "films", "videos", "games", "music", "celebrities", "podcasts", "websites", "social_media"] },
  { name: "title", label: "Title" },
  { name: "description", label: "Description", type: "textarea" },
  { name: "link", label: "Link URL" },
  { name: "image_url", label: "Image URL" },
  { name: "year", label: "Year" },
];

const faqFields = [
  { name: "category", label: "Category", type: "select", options: ["History", "Stadiums", "Trophies", "Legends", "1966 World Cup", "Club Culture", "Managers", "Premier League", "Records", "Rivalries", "Youth Academy", "Memorable Matches", "Women's Team", "Kit & Colours", "Modern Era", "Cup Competitions", "Fans & Community", "Notable Facts", "Match Day"] },
  { name: "question", label: "Question" },
  { name: "answer", label: "Answer", type: "textarea" },
  { name: "order", label: "Order" },
];

const chantFields = [
  { name: "category", label: "Category", type: "select", options: ["Anthem", "Classic", "Modern", "Legend", "Player", "Cup", "Rivalry"] },
  { name: "title", label: "Title" },
  { name: "lyrics", label: "Lyrics", type: "textarea" },
  { name: "description", label: "Description (short blurb, ~30 words)", type: "textarea" },
  { name: "long_context", label: "Long Context (LLM-generated, ~100 words · shown as 'About this chant' on public page)", type: "textarea", aiRegenerate: "chants" },
  { name: "order", label: "Order" },
];

// Main Admin Page
export default function AdminPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex" data-testid="admin-page">
      <AdminSidebar />
      
      <div className="flex-1 p-8 overflow-auto">
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="analytics" element={<AnalyticsAdmin />} />
          <Route path="notifications" element={<NotificationsAdmin />} />
          <Route path="discount-codes" element={<DiscountCodesAdmin />} />
          <Route path="fixtures" element={<FixturesAdmin />} />
          <Route path="tables" element={<TablesAdmin />} />
          <Route path="stats" element={<StatsAdmin />} />
          <Route path="players" element={<PlayersAdmin />} />
          <Route path="history" element={<HistoryAdmin />} />
          <Route path="cups" element={<CupsAdmin />} />
          <Route path="fan-clubs" element={<FanClubsAdmin />} />
          <Route path="fan-memories" element={<FanMemoriesAdmin />} />
          <Route path="shop" element={<ShopAdmin />} />
          <Route path="entertainment" element={
            <CrudSection 
              title="ENTERTAINMENT" 
              endpoint="entertainment" 
              fields={entertainmentFields}
              filterField={entertainmentFields[0]}
            />
          } />
          <Route path="news" element={<NewsAdmin />} />
          <Route path="forum" element={<ForumAdmin />} />
          <Route path="faqs" element={
            <CrudSection 
              title="FAQS" 
              endpoint="faqs" 
              fields={faqFields}
              filterField={faqFields[0]}
            />
          } />
          <Route path="on-this-day" element={<OnThisDayAdmin />} />
          <Route path="chants" element={
            <CrudSection 
              title="CHANTS" 
              endpoint="chants" 
              fields={chantFields}
              filterField={chantFields[0]}
            />
          } />
          <Route path="memes" element={<MemesAdmin />} />
          <Route path="transfers" element={<TransfersAdmin />} />
          <Route path="seo-health" element={<SeoHealthAdmin />} />
          <Route path="users" element={<UsersAdmin />} />
        </Routes>
      </div>
    </div>
  );
}
